import { IconSearch, IconUser, IconChevronDown } from "@tabler/icons-react";

export interface InvoiceArchiveFiltersProps {
  invoiceIdSearch: string;
  customerSearch: string;
  customerOptions: string[];
  onInvoiceIdSearchChange: (value: string) => void;
  onCustomerSearchChange: (value: string) => void;
  onClearFilters: () => void;
}

export const InvoiceArchiveFilters = ({
  invoiceIdSearch,
  customerSearch,
  customerOptions,
  onInvoiceIdSearchChange,
  onCustomerSearchChange,
  onClearFilters,
}: InvoiceArchiveFiltersProps) => {
  const hasActiveFilters = invoiceIdSearch || customerSearch;

  return (
    <div className="flex flex-col sm:flex-row gap-4 bg-white rounded-lg p-4 shadow-sm border border-gray-200">
      {/* Invoice ID Search */}
      <div className="flex-1">
        <label
          htmlFor="invoice-id-search"
          className="block text-sm font-medium text-gray-700 mb-2"
        >
          Search by Invoice ID
        </label>
        <div className="relative">
          <IconSearch
            size={18}
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
          />
          <input
            id="invoice-id-search"
            type="text"
            value={invoiceIdSearch}
            onChange={(e) => onInvoiceIdSearchChange(e.target.value)}
            placeholder="Enter invoice ID..."
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-slate-500 focus:border-slate-500 outline-none transition"
          />
        </div>
      </div>

      {/* Customer Select */}
      <div className="flex-1">
        <label
          htmlFor="customer-select"
          className="block text-sm font-medium text-gray-700 mb-2"
        >
          Filter by Customer
        </label>
        <div className="relative">
          <IconUser
            size={18}
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none z-10"
          />
          <select
            id="customer-select"
            value={customerSearch}
            onChange={(e) => onCustomerSearchChange(e.target.value)}
            className="w-full pl-10 pr-10 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-slate-500 focus:border-slate-500 outline-none transition appearance-none bg-white"
          >
            <option value="">All Customers</option>
            {customerOptions.map((customer) => (
              <option key={customer} value={customer}>
                {customer}
              </option>
            ))}
          </select>
          <IconChevronDown
            size={18}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none z-10"
          />
        </div>
      </div>

      {/* Clear Filters Button */}
      {hasActiveFilters && (
        <div className="flex items-end">
          <button
            onClick={onClearFilters}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition border border-gray-300"
          >
            Clear Filters
          </button>
        </div>
      )}
    </div>
  );
};
